import { create } from 'zustand';
import axios from 'axios';
import { Toast } from '@kibt/meta-ui-krn';
import { $k18n } from '@/common/i18n';
import { setSameDomainCookie } from '@/common/device-info';
import { isStaging } from '@/common/api';

export interface IState {
    // 登录弹窗是否打开
    loginModelVisible: boolean;
    setLoginModelVisible: (visible: boolean) => void;
    getUserInfo: () => Promise<any>;
    logout: () => Promise<boolean>;
    userInfo: any;
    isLogin: boolean;
}

export const useLoginStore = create<IState>((set, get) => ({
    loginModelVisible: false,
    userInfo: {},
    isLogin: false,
    setLoginModelVisible: visible => {
        set({
            loginModelVisible: visible,
        });
    },

    getUserInfo: async () => {
        const res = await axios.post(`/rest/o/w/user/login/visitor/info`);
        const data = res?.data || {};
        if (data?.result === 1) {
            if (data?.user.user_id) {
                setSameDomainCookie('user_id', data?.user.user_id);
            }
            set({
                userInfo: data?.user,
                isLogin: true,
            });
        }
        return res?.data || {};
    },
    logout: async () => {
        const res = await axios.get(`/rest/o/w/account/logout`);
        const { data } = res || {};
        if (data?.result !== 1) {
            data?.error_msg && Toast.show(data?.error_msg);
            return;
        }
        set({
            userInfo: {},
            isLogin: false,
        });
        return true;
    },
}));
